import { render, staticRenderFns } from "./GoodsCost.vue?vue&type=template&id=57d59f5d&scoped=true&"
import script from "./GoodsCost.vue?vue&type=script&lang=js&"
export * from "./GoodsCost.vue?vue&type=script&lang=js&"
import style0 from "./GoodsCost.vue?vue&type=style&index=0&id=57d59f5d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57d59f5d",
  null
  
)

export default component.exports